import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import CityCollabSettingService from "@/services/APIs/CityCollabSettingService";

const InvitePage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const refer_code = searchParams.get("refer_code");
  const hasValidated = useRef(false); // 👈 Guard flag
  useEffect(() => {
    const validateToken = async () => {
      if (hasValidated.current) {
        return;
      }
      hasValidated.current = true;
      const accessToken = localStorage.getItem("accessToken");

      if (!refer_code) {
        navigate("/auth");
        return;
      }
      try {
        const response = await CityCollabSettingService.validateInviteToken({
          invite_code: refer_code,
        });
        if (response?.status === "success") {
          localStorage.setItem("OrganizationId", response.organization_id);
          localStorage.setItem("MemberShipTypeId", response.membership_type_id);
          localStorage.setItem("OrganizationName", response.organization_name);
          localStorage.setItem("DepartmentId", response.department_id);

          if (accessToken) {
            console.log("accessToken", accessToken);
            navigate("/auth");
            return;
          }

          navigate("/auth");
        }
      } catch (err) {
        console.error("Invite validation failed:", err);
        navigate("/auth");
      }
    };

    validateToken();
  }, [refer_code, navigate]);

  return <div>Loading...</div>;
};

export default InvitePage;
